import { useEffect, useMemo } from "react";
import { Flex, Paper, Text } from "@pillar-ui/core";
import { CircleCheck, CircleInfo, ExclamationCircle } from "@pillar-ui/icons";
import colors from "../styles/colors";
import { APP_MAX_WIDTH } from "../styles/variables";

const Toast = ({ open, message, duration = 2000, onClose, variant }) => {
  const toastIcon = useMemo(() => {
    const iconProps = {
      color: colors.white,
      height: 32,
      width: 32,
    };
    switch (variant) {
      case "danger":
        return <ExclamationCircle {...iconProps} />;
      case "success":
        return <CircleCheck {...iconProps} />;
      default:
        return <CircleInfo {...iconProps} />;
    }
  }, [variant]);

  const background = useMemo(() => {
    switch (variant) {
      case "danger":
        return "D9";
      case "success":
        return "Su9";
      default:
        return "I9";
    }
  }, [variant]);

  useEffect(() => {
    const handle = setTimeout(() => {
      onClose?.();
    }, duration);
    return () => clearTimeout(handle);
  }, [duration, onClose]);

  if (!open) return null;
  return (
    <Paper
      p="6"
      background={background}
      corner="4"
      shadow="2"
      style={{
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        bottom: 40,
        left: 20,
        zIndex: 1000,
        width: "calc(100% - 40px)",
        maxWidth: APP_MAX_WIDTH - 40,
      }}
    >
      <Flex items="center" gap="4">
        {toastIcon}
        <Text size="8" weight="6" style={{ color: colors.white }}>
          {message}
        </Text>
      </Flex>
    </Paper>
  );
};

export default Toast;
